/**
 * Determines the index of the provided node (among its siblings).
 *
 * This is needed because a DOM node doesn't know its own index, so we have to
 * look at the parent, and its children(/our element's siblings).
 */
export const determineElementIndex = el =>
  Array.from(el.parentNode.children).indexOf(el);
